<template>
    <v-menu v-model="menu" :close-on-content-click="false" transition="scale-transition" offset-y>
        <template v-slot:activator="{ on, attrs }">
            <v-text-field dense hide-details :value="display" :label="label" prepend-inner-icon="mdi-calendar" outlined readonly v-bind="attrs" v-on="on" :disabled="disabled"></v-text-field>
        </template>
        <v-date-picker no-title :value="picker" @input="input"></v-date-picker>
    </v-menu>
</template>

<script>
    import moment from 'moment';

    export default {
        data: () => ({
            menu: false
        }),
        props: {
            value: {
                type: String,
                default: null
            },
            label: {
                type: String,
                default: ''
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            picker() {
                return this.value ? moment(this.value).format('YYYY-MM-DD') : undefined;
            },
            display() {
                return this.value ? moment(this.value).format('L') : undefined;
            }
        },
        methods: {
            input(val) {
                this.$emit('input', moment(val).toISOString());
                this.menu = false;
            }
        }
    };
</script>
